import { Box, Card, Container, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GaugeChart from 'react-gauge-chart'

import WmsCard from '../WMS/WmsCard'
import Image from 'mui-image'
import ReactSpeedometer from "react-d3-speedometer"
import { Constants } from '../../utils/Constants'


function TempMeter({ title, data,menuItem }) {
    const MeterData = data[0]
    // const [MeterData, setMeterData] = useState({})
    // console.log('meterData', MeterData)
    // console.log(typeof (parseInt(MeterData?.max_range)))
    const [MAXVAL, setMAXVAL] = useState(parseInt(MeterData?.max_range))
    // useEffect(() => {
    //     setMeterData({ ...Data })
    // }, [Data])

    const { palette, breakpoints } = useTheme()
    const lgs = useMediaQuery(breakpoints.down('lg'))

    return (
        <Box component={Card} height={'100%'}>
            <Box sx={{ visibility: title == 'Multiple Module Temperature' ? 'hidden' : 'unset' }}>
                {/* <Container>
                    <GaugeChart id="gauge-chart5"
                        nrOfLevels={420}
                        arcsLength={[0.3, 0.5, 0.2]}
                        colors={['#FED7AA', '#FB923C', '#EA580C']}
                        percent={title == "Solar Insolation" ? MeterData?.['Solar Insolation'] : MeterData?.LIVE_VALUE}
                        textColor={palette.primary.dark}
                        cornerRadius={0}
                        hideText
                        animate={false}
                        style={{ width: 'auto', margin: 'auto' }}
                        arcPadding={0.0}
                    />
                </Container> */}

                <Box sx={{ justifyContent: 'center', display: "flex" }}>
                    <div>
                        {/* {console.log(MeterData?.max_range, typeof (+MeterData?.max_range))} */}
                        <ReactSpeedometer
                            // width={400}
                            paddingHorizontal={10}
                            paddingVertical={20}
                            height={200}
                            segments={2}
                            value={title === "Solar Insolation" ? MeterData?.['Solar Insolation'] : MeterData?.LIVE_VALUE}
                            currentValueText={MeterData?.LIVE_VALUE?.length <= 0 || MeterData?.LIVE_VALUE == undefined ? "0" : title === "Solar Insolation" ? MeterData?.['Solar Insolation'] + ' ' + MeterData?.UNIT : MeterData?.LIVE_VALUE + ' ' + MeterData?.UNIT}
                            minValue={0}
                            maxValue={
                                title === "Solar Irradiation" ? 2500 : title === "Wind Speed" || title === "Module Temperature" || title === "Ambient Temperature" || title === "Humidity" ? 100 : title === "Solar Insolation" ? 10 : title === "RAIN" ? 1500 : null
                            }
                            segmentColors={['#FED7AA', '#FB923C', '#EA580C']}
                            needleColor={palette.primary.main}
                            textColor={palette.primary.main}
                        />
                    </div>
                </Box>

                {/* <Typography component={Paper} bgcolor={palette.primary.light} width={'10rem'} m={'auto'} textAlign={'center'} variant='h5'>{MeterData?.LIVE_VALUE ? `${MeterData?.LIVE_VALUE} ${MeterData?.UNIT}` : '____'}</Typography> */}

                <Stack sx={{ mx: 2 }}>
                    <WmsCard
                        // StartIcon={
                        //     // <Image
                        //     //     src={}
                        //     //     width={lgs ? 80 : 60}
                        //     //     height={"fit-content"}
                        //     // />
                        //     Constants()[title] ? Constants()[title] : <Image width={90} height={'auto'} src={require('../../assets/img/blank.png')} />
                        // }

                        StartIcon={
                            title?.toLowerCase().startsWith("solar") ? (
                                <Image width={70} height={'auto'} src={require('../../assets/img/logos/sun.png')} />
                            ) : Constants()[title] ? (
                                Constants()[title]
                            ) : (
                                <Image width={90} height={'auto'} src={require('../../assets/img/blank.png')} />
                            )
                        }

                        WmsCardStyle={{ border: 0, flex: 1, backgroundColor: '#FDF8E4' }}
                        title={title}
                        menuItem={menuItem}
                        boldTitle={title == "Solar Insolation" ? MeterData?.['Solar Insolation'] + " " + MeterData?.UNIT : MeterData?.LIVE_VALUE ? MeterData?.LIVE_VALUE + ' ' + MeterData?.UNIT : '____'}
                        LiveDate={MeterData?.LIVE_DATE_TIME}
                        minValue={MeterData?.MIN_VALUE}
                        minDate={MeterData?.MIN_DATE_TIME}
                        maxValue={MeterData?.MAX_VALUE}
                        maxDate={MeterData?.MAX_DATE_TIME}
                        avgValue={MeterData?.AVG_VALUE}
                        rightTitle={title == 'Wind Direction' ? null : MeterData?.UD}
                    />
                </Stack>

            </Box>

        </Box>
    )
}

export default TempMeter
